import { useFieldsWidgetContext } from './fields-widget.context';
import { SearchAndSelectWidget } from '../filter-widget/filter-widget.component';

export const FieldsWidget = props => {
  const { data, selectedTypes } = useFieldsWidgetContext();

  return (
    <SearchAndSelectWidget
      {...props}
      data={data}
      selectedTypes={selectedTypes}
    />
  );
};
